import React, { useState } from 'react';
import { CTooltip } from '@coreui/react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { trackEvent } from 'src/utils/mixpanel';
import DailyReportV2 from './Reports/DailyReportV2';
import SwaV2 from './Reports/SwaV2';
import SiteVisitV2 from './Reports/SiteVisitV2';
import Weekly from './Weekly';
import Timeline from './Timeline';
import TwoWeeks from './TwoWeeks';
import HistoricalReports from './HistoricalReports';
import ProjectTabs from '../projects/ProjectTabs';

const Report = () => {
  const { id: projectID } = useParams();
  const [active, setActive] = useState(1);
  const tabWarnings = useSelector((state) => state.project.tabWarnings[projectID]);

  const reportTabs = [
    { id: 1, name: 'Daily', label: 'Daily' },
    { id: 2, name: 'Current Week', label: 'Weekly Progress' },
    {
      id: 7,
      name: 'Historical Report',
      label: 'Historical Progress',
      badge: tabWarnings?.historical_report > 0 ? tabWarnings.historical_report : null,
      tooltip: `There ${tabWarnings?.historical_report > 1 ? 'are' : 'is'} ${tabWarnings?.historical_report} missing Historical Reports. Please input the missing Historical Report`,
    },
    { id: 3, name: 'Two Weeks Ahead', label: 'Two Weeks Ahead' },
    { id: 4, name: 'SWA', label: 'SWA' },
    { id: 5, name: 'Site Visit', label: 'Site Visit' },
    { id: 6, name: 'Upload History', label: 'Upload History' },
  ];

  const handleTabNavigate = (idx, name) => {
    setActive(idx);
    trackEvent(`Click to Report - ${name}`, {
      Source: 'Project - Report',
      'AIMHI Version': 1,
    });
  };

  return (
    <>
      <ProjectTabs />

      <div className="w-full mt-3 mb-4">
        <div className="w-full flex items-center gap-1 p-1 bg-gray-100 rounded-xl border border-gray-200 overflow-x-auto no-scrollbar">
          {reportTabs.map((tab) => {
            const isActive = active === tab.id;
            const buttonContent = (
              <button
                key={tab.id}
                type="button"
                onClick={() => handleTabNavigate(tab.id, tab.name)}
                className={`flex-1 min-w-[110px] md:min-w-0 shrink-0 md:shrink relative inline-flex items-center justify-center gap-2 px-3 py-2 text-xs font-medium rounded-lg transition-all duration-200 cursor-pointer select-none whitespace-nowrap active:scale-[0.98] ${isActive
                  ? 'bg-aimhi-textlight-neutral text-white shadow-xs'
                  : 'text-aimhi-textlight-neutral/75 hover:text-white hover:!bg-aimhi-textlight-neutral bg-transparent'
                  }`}
              >
                <span>{tab.label}</span>

                {tab.badge && (
                  <span
                    className="shrink-0 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-bold rounded-full bg-aimhi-danger text-white"
                  >
                    {tab.badge}
                  </span>
                )}
              </button>
            );

            if (tab.badge && tab.tooltip) {
              return (
                <CTooltip key={tab.id} content={tab.tooltip} placement="top">
                  {buttonContent}
                </CTooltip>
              );
            }

            return buttonContent;
          })}
        </div>
      </div>

      {/* Tab Panels */}
      <div className="w-full">
        {active === 1 && <DailyReportV2 id={projectID} />}
        {active === 2 && <Weekly id={projectID} />}
        {active === 3 && <TwoWeeks id={projectID} />}
        {active === 4 && <SwaV2 id={projectID} />}
        {active === 5 && <SiteVisitV2 id={projectID} />}
        {active === 6 && <Timeline project_id={projectID} />}
        {active === 7 && <HistoricalReports id={projectID} />}
      </div>
    </>
  );
};

export default Report;

